import { createContext, useContext } from 'react';

import { ISelectOption } from '~/src/dash/components/dropdowns/common';

interface IForecastingFormContext {
  inventoryParametersLists: Record<string, ISelectOption[]>;
}

export const ForecastingFormContext = createContext({} as IForecastingFormContext);
export const useForecastingFormStore = (): IForecastingFormContext =>
  useContext(ForecastingFormContext);
